export enum HighCommissionBoosting {
  NAME = 'plp_hc_boosting',
  OFF = 'off',
  ON = 'on',
}

export enum ClpPopulation {
  AUTO = 'auto',
  NAME = 'clp_population',
  QUERY = 'query',
}

export enum PplpLayout {
  ENHANCED = 'enhanced',
  NAME = 'pplp_layout',
  STANDARD = 'standard',
}
